import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import { Row, Col } from 'react-flexbox-grid'
import {
  ContainerDivs,
  AutocompleteSearch,
  SjfIssueCards,
  Link,
  LinkIcon,
  SrOnly,
  InlineSignup,
  AykCtaPanel,
} from '../../components'
import Styles from './Home.css'


@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    // IMAGES
    const aysLogo = require('../../../static/images/AYS_R+large+RGB.jpg')
    const graphicLede = require('../../../static/images/sjf-people-charts-savings-graphic.png')
    const graphicMethodology = require('../../../static/images/v2_Methodology clipboard.png')
    const graphicReport = require('../../../static/images/sjf-chart-savings-graphic.png')

    //
    return <div>

      <section styleName='hero'>
        <ContainerDivs>
          <div styleName='hero__content'>

            <h1 styleName='hero__title'>
              <span>Social justice</span> investing made easy
            </h1>

            <p styleName='hero__subtitle'>
              See how your savings score on gender equality,
              racial justice, LGBTQ+ equity, and diversity disclosures
            </p>

            <div styleName='hero__search'>
              <AutocompleteSearch />
            </div>

            <div styleName='hero__btn'>
              <Link
                to={config.routes.clean}
                roundbutton
                title='Top-scoring funds'
              >
                <div>
                  Top-scoring funds<LinkIcon />
                </div>
              </Link>
            </div>

            <div styleName='hero__logo'>
              <div styleName='hero__logo-tagline'>
                A project of
              </div>
              <Link to={config.links.ays} title='As You Sow'>
                <img
                  styleName='hero__logo-img'
                  src={aysLogo}
                  alt='As You Sow'
                />
                <SrOnly>As You Sow</SrOnly>
              </Link>
            </div>

          </div>
        </ContainerDivs>
      </section>

      <AykCtaPanel />

      <section>
        <ContainerDivs>
          <div styleName='flexpanel'>
            <h2 styleName='flexpanel__headline'>
              Turn your savings into a catalyst for social change
            </h2>
            <div styleName='flexpanel__content'>
              <div styleName='flexpanel__l-content'>
                <p styleName='flexpanel__copy'>

                  Responsible investors want to support companies that
                  foster a culture based on justice and equity,
                  promoting diversity across
                  gender, race, ethnicity, sexual orientation,
                  and other federally protected classes.

                  But the data can be hard to find, especially when investing
                  in mutual funds and other investment vehicles that hold
                  hundreds or even thousands of individual companies.

                </p>
                <p styleName='flexpanel__copy'>
                  <b>That's why we built Social Justice Funds.&nbsp;</b>

                  Our database brings together research on a range of
                  social justice issues to give you a way to find
                  portfolios that align with your values.
                </p>
              </div>
              <div styleName='flexpanel__r-content'>
                <img
                  styleName='flexpanel__img'
                  src={graphicLede}
                  alt='Turn your savings into a catalyst for social change'
                />
              </div>
            </div>
            <Link
              to={config.routes.clean}
              roundbutton
              title='Fund database'
            >
              <div>
                Fund database<LinkIcon />
              </div>
            </Link>
          </div>
        </ContainerDivs>
      </section>


      <section styleName='sjf-issue-cards-wrapper'>
        <ContainerDivs>
          <SjfIssueCards />
        </ContainerDivs>
      </section>


      <section>
        <ContainerDivs>
          <div styleName='flexpanel'>
            <h2 styleName='flexpanel__headline'>
              The "Diversity Dividend" &mdash; Workforce diversity is linked
              to financial performance
            </h2>
            <div styleName='flexpanel__content'>
              <div styleName='flexpanel__l-content'>
                <p styleName='flexpanel__copy'>
                  A diverse workforce led by a diverse management team
                  performs better financially.

                  Our analysis of over 1,600 companies
                  found a statistically significant correlation
                  between higher percentages of BIPOC (Black, Indigenous,
                    and People of Color) management and increases in
                  enterprise value growth rate, free cash flow per share,
                  income after tax, long-term growth mean,
                  10-year price change, mean return on equity (ROE),
                  return on invested capital (ROIC), and 10-year total
                  revenue compound annual growth rate (CAGR).
                </p>
                <p styleName='flexpanel__copy'>
                  It's part of a growing body of evidence linking financial
                  benefits to a diverse management team, making a clear
                  business and investor case for diversity as a material
                  factor in financial success.
                </p>
              </div>
              <div styleName='flexpanel__r-content'>
                <img
                  styleName='flexpanel__img'
                  src={graphicReport}
                  alt='Workforce diversity is linked to financial performance'
                />
              </div>
            </div>
            <Link
              to='https://www.asyousow.org/reports/2023-capturing-the-diversity-benefit'
              roundbutton
              title='Capturing the Diversity Benefit'
            >
              <div>
                Read the report<LinkIcon />
              </div>
            </Link>
          </div>
        </ContainerDivs>
      </section>


      <section>
        <ContainerDivs>
          <InlineSignup />
        </ContainerDivs>
      </section>


      <section>
        <ContainerDivs>
          <div styleName='flexpanel'>
            <div styleName='flexpanel__content'>
              <div styleName='flexpanel__l-content'>
                <h2 styleName='flexpanel__headline'>
                  How we grade funds on social justice issues
                </h2>
                
                <p styleName='flexpanel__copy'>
                  We've rated over 5,000 mutual funds on social justice
                  issues,

                  using data on corporate diversity, equity, and
                  inclusion efforts from expert research groups like
                  Equileap, Human Rights Campaign, and Whistle Stop.

                  Read our full methodology to see how we assign social
                  justice ratings to mutual funds, ETFs, and 401(k)s.
                </p>
              </div>
              <div styleName='flexpanel__r-content'>
                <img
                  styleName='flexpanel__img'
                  src={graphicMethodology}
                  alt='How we grade funds'
                />
              </div>
            </div>
            <Link
              to={config.routes.methodology}
              roundbutton
              title='Methodology'
            >
              <div>
                Methodology<LinkIcon />
              </div>
            </Link>
          </div>
        </ContainerDivs>
      </section>


    </div>
  }
}

